export default __webpack_public_path__ + "static/media/parse-xml.dededb26.svg";